import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Form from "../../../../components/Form/Form";
import FormTitle from "../../../../components/FormTitle/FormTitle";
import Input from "../../../../components/Input/Input";
import Loader from "../../../../components/Loader/Loader";
import { useListManager } from "../../../../contexts/list.manager";
import "./FormGroups.css";
import GroupService from "../../../../services/GroupsService";
import { LevelSelector } from "../../../../components/LevelSelector/LevelSelector";
import { LuUsers } from "react-icons/lu";
import { PoliciesDDL } from "../../../../components/PoliciesDDL/PoliciesDDL";

function FormGroups(props) {
	const [name, setName] = useState(props.group?.name || "");
	const [selectedPolicies, setSelectedPolicies] = useState(null);
	const [levels, setLevels] = useState([]);
	const [showLoader, setShowLoader] = useState(false);
	const { closeForm } = useListManager();
	const navigate = useNavigate();

	useEffect(() => {
		setName(props.group?.name || "");
		setSelectedPolicies(props.group?.policies || []);
		setLevels(props.group?.levels?.map(level => ({ unitId: `${level.unitId}`, hierarchy: level.childrenAuthorized })) || []);
	}, [props.group]);

	const buildPayload = () => {
		return {
			name,
			policies: selectedPolicies?.map(selectedPolicy => selectedPolicy.value),
			levels: levels.map(level => ({
				unitId: isNaN(`${level.unitId}`) ? 'root' : `${level.unitId}`,
				childrenAuthorized: level.hierarchy
			})),
		};
	};

	async function handleSubmit(event) {
		event.preventDefault();
		if (props.type === "edicao") {
			handleEdit();
			return;
		}
		setShowLoader(true);
		const payload = buildPayload();
		const response = await GroupService.createGroup(payload);
		setShowLoader(false);
		if (response.data.id) navigate("../consulta-grupos", {
			state: { refresh: true }
		});
	}

	async function handleEdit() {
		setShowLoader(true);
		const payload = buildPayload();
		const response = await GroupService.updateGroup(
			props.group.id,
			payload
		);
		setShowLoader(false);
		if (response.data.id) navigate("../consulta-grupos");
	}

	async function handleDelete() {
		setShowLoader(true);
		if (!props.group) return;
		await GroupService.deleteGroup(props.group.id);
		navigate("../consulta-grupos", {
			state: { deletedId: props.group.id },
		});
		setShowLoader(false);
		closeForm();
	}

	const handleClickEditButton = () => {
		if (!props.group) return;
		navigate(`/grupos/${props.group.externalId}`, { state: props.group });
	};

	const handleDualList = (notSelected, selected) => {
		setSelectedPolicies(selected);
	};

	return (
		<React.Fragment>
			<FormTitle
				type={props.type}
				icon={<LuUsers size={20} />}
				tituloConsulta={props.group?.name || null}
				tituloCadastro="Cadastro de Grupos"
				backRoute={"/consulta-grupos"}
			/>
			{showLoader ? (
				<Loader />
			) : (
				<Form
					handleSubmit={handleSubmit}
					type={props.type}
					handleDelete={handleDelete}
					handleClickEdit={handleClickEditButton}
					navigateCancelUrl="../consulta-grupos"
				>
					<div className="group-form-grid">
						<Input
							name="name"
							id="name"
							labelText="Nome do grupo *"
							value={name}
							onChange={({ target }) => setName(target.value)}
							disabled={props.type === "consulta"}
							required={true}
						/>
						{props.type !== "consulta" && (
							<>
								<LevelSelector
									onChange={(levels) => {
										setLevels(levels.map(level => ({
											unitId: level.unitId,
											hierarchy: level.childrenAuthorized
										})));
									}}
									levels={levels.map(level => ({
										unitId: level.unitId,
										childrenAuthorized: level.hierarchy
									}))}
									showRoot={true}
									type={props.type}
									title={"Níveis"}
									description={"Selecione os níveis que o grupo pertence"} />
								{selectedPolicies && (
									<div className="form-cond-dual-list-container w-full">
										<PoliciesDDL
											onChangeList={handleDualList}
											policies={selectedPolicies}
										/>
									</div>
								)}
							</>
						)}
					</div>
				</Form>
			)}
		</React.Fragment>
	);
}

export default FormGroups;
